const tipoHistoricoAluno = [
  { text: 'Entrada', value: 1, color: '#A0D995' },
  { text: 'Saída', value: 2, color: '#FF8A80' },
  { text: 'Transf. entrada', value: 3, color: '#82C4E8' },
  { text: 'Transf. saída', value: 4, color: '#F5A17D' },
];

export default tipoHistoricoAluno;
